import Vue from 'vue'
import Router from 'vue-router'
import { FASTORDER } from '@/constants'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ './view/index'),
    meta: {
      title: 'Home'
    }
  }, {
    path: '/page404',
    name: 'page404',
    component: () => import(/* webpackChunkName: "page404" */ './view/page404'),
    meta: {
      title: `${FASTORDER} -- Notice`,
      keepAlive: false,
    }
  }, {
    path: '/scanqr',
    name: 'scanQR',
    component: () => import(/* webpackChunkName: "scan" */ './view/index/ScanQR'),
    meta: {
      title: 'Scan QR',
      keepAlive: false,
    }
  }, {
    path: '/user/addressList',
    name: 'userAddressList',
    component: () => import(/* webpackChunkName: "addresslist" */ './view/user/addressList.vue'),
    meta: {
      title: `${FASTORDER} -- Notice`,
      keepAlive: false,
    }
  }, {
    path: '/user/addressDetail',
    name: 'userAddressDetail',
    component: () => import(/* webpackChunkName: "addressDetail" */ './view/user/addressDetail.vue'),
    meta: {
      title: `${FASTORDER} -- Notice`,
      keepAlive: false,
    }
  }, {
    path: '/order/driverArrived',
    name: 'orderDriverArrived',
    component: () => import(/* webpackChunkName: "orderdelivery" */ './view/order/orderDelivery.vue'),
    meta: {
      title: 'My Rider',
      keepAlive: false,
    }
  }, {
    path: '/merchant/index',
    name: 'merchantIndexList',
    component: () => import(/* webpackChunkName: "merchant" */ './view/merchant/index.vue'),
    meta: {
      title: 'Store List',
      keepAlive: false,
    }
  }, {
    path: '/order/deliveryProcessing',
    name: 'orderDeliveryProcessing',
    component: () => import(/* webpackChunkName: "deliveryorderProcess" */ './view/order/deliveryOrderProcessing.vue'),
    meta: {
      title: 'Delivery Processing',
      keepAlive: false,
    }
  }, {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ './view/cart/index.vue'),
    meta: {
      title: 'Cart',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/shop/index',
    name: 'shopIndex',
    component: () => import(/* webpackChunkName: "shop" */ './view/shop/index.vue'),
    meta: {
      title: 'Merchant',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/googlemap',
    name: 'googlemap',
    component: () => import(/* webpackChunkName: "googlemap" */ './view/index/googleMap.vue'),
    meta: {
      title: 'Google Map Test',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/delivery',
    name: 'deliveryCart',
    component: () => import(/* webpackChunkName: "delivery" */ './view/cart/delivery.vue'),
    meta: {
      title: 'Delivery',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/delivery/shipment',
    name: 'deliveryShipment',
    component: () => import(/* webpackChunkName: "shipment" */ './view/cart/shipment.vue'),
    meta: {
      title: 'Choose Ship Type',
      keepAlive: false,
    }
  },
  {
    path: '/takeaway',
    name: 'takeawayCart',
    component: () => import(/* webpackChunkName: "takeaway" */ './view/cart/takeaway.vue'),
    meta: {
      title: 'Takeaway',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/order/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "history" */ './view/order/history'),
    meta: {
      title: 'Order History'
    }
  }, {
    path: '/order',
    name: 'order',
    component: () => import(/* webpackChunkName: "order" */ './view/order'),
    meta: {
      title: 'Order Detail'
    }
  },
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
})

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  const param = 'fbclid';
  if(location.search.indexOf(param + '=') !== -1){
    let replace = '';
    const splitter =(string) =>{
      return string.split('#').join('').split('?').join('').split('/').join('').split('&')
    }
    try {
      const url = new URL(location);
      url.searchParams.delete(param);
      const joinStringUrl = url.search + '&' +url.hash
      let splitArray = splitter(joinStringUrl)
      let hashUrlParam= '#/?'+splitArray.filter( string => string !== '').join('&')
      replace = url.pathname + hashUrlParam
    } catch (ex) {
      let regExp = new RegExp('[?&]' + param + '=.*$');
      replace = location.search.replace(regExp, '');
      let splitArray = splitter(location.hash)
      let hashUrlParam ='#/?'+ splitArray.filter( string => string !== '').join('&')
      replace = location.pathname + replace + hashUrlParam;
    }
    history.pushState({}, '', replace);
    location.reload()
  }
  else next ();
})

export {
  router
}